module.exports = "/assets/82fa8ad7c3967e9a6d452bd1f8a6d540.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7R.png
// module id = 1121
// module chunks = 0